import React from 'react';
import PropTypes from 'prop-types';

import { DlocalForm as Dlocal } from './Dlocal';
import CreditCardDefaultForm from './Default/CreditCardDefaultForm';

const FormProvider = ({ paymentGateway, ...props }) => {
  props.paymentGateway = paymentGateway;

  return paymentGateway?.gatewayCode === 'Dlocal' ? (
    <Dlocal {...props} />
  ) : (
    <CreditCardDefaultForm {...props} />
  );
};

FormProvider.propTypes = {
  paymentGateway: PropTypes.object,
  onCreate: PropTypes.func,
  onChange: PropTypes.func,
  onCancel: PropTypes.func,
  onFinish: PropTypes.func,
  getProduct: PropTypes.func,
  allowedCountries: PropTypes.array,
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default FormProvider;
